import styled from "styled-components";
import { Select } from "antd";
import { fontColor } from 'Public/Css/colors';


export default styled( Select ) `
    width: 100%;
    min-width: 85px;
    height: 32px;
  
    &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
        height: 32px;
        
        .ant-select-selection-search-input {
            height: 30px;
            line-height: 30px;
        }
    }

    &.ant-select-single.ant-select-show-arrow .ant-select-selection-item, .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
        line-height: 30px;
    }
    
    &.ant-select-single .ant-select-selector .ant-select-selection-item, 
    &.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
        line-height: 30px;
    }

    &:not(.ant-select-customize-input) .ant-select-selector {
        border: solid 1px ${ fontColor };
    }
    
`;
